import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

const HIDE_ROUTES = ["/contact", "/admin", "/admin/login", "/client", "/client/login", "/apply", "/jobs", "/insights", "/book-diagnostic"];
const EASE = [0.76, 0, 0.24, 1];

/**
 * Floating "Book a diagnostic call" pill that appears after the user
 * has scrolled past the hero (>60% of viewport). Hidden on HIDE_ROUTES.
 */
export const StickyDiscoveryCTA = () => {
  const [visible, setVisible] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => {
      const threshold = window.innerHeight * 0.65;
      setVisible(window.scrollY > threshold);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const hidden = HIDE_ROUTES.some((r) => pathname === r || pathname.startsWith(r + "/"));
  const shouldShow = visible && !hidden;

  return (
    <AnimatePresence>
      {shouldShow && (
        <motion.div
          initial={{ opacity: 0, y: 40, scale: 0.9 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 40, scale: 0.9 }}
          transition={{ duration: 0.5, ease: EASE }}
          className="fixed bottom-6 right-6 md:bottom-8 md:right-8 z-40"
        >
          <Link
            to="/book-diagnostic"
            className="btn-pill shadow-[0_10px_40px_rgba(217,93,57,0.25)]"
            data-testid="sticky-discovery-cta"
          >
            <span className="hidden sm:inline">Book a diagnostic call</span>
            <span className="sm:hidden">Book a call</span>
            <ArrowUpRight className="w-4 h-4" strokeWidth={1.6} />
          </Link>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default StickyDiscoveryCTA;
